import React from 'react';
import style from './PortletTitle.scss';
import { useDeviceSelector } from 'js/store/hooks';
import { prop } from 'ramda';

export const PortletTitle = ({ portlet }) => {
    const { title, showTitle, portletType } = portlet;
    const isMobile = useDeviceSelector(prop('isMobile'));
    const isRegisterPage = portletType === 'registration';
    const hideTitleForRegister = !isMobile && isRegisterPage;

    if (!showTitle || !title || !hideTitleForRegister) {
        return null;
    }

    return (
        <h1 className={`${style.title} ${isRegisterPage && style.registerTitle} fn-portlet-title`}>{title}</h1>
    );
};
